import React, { useContext, useEffect, useState } from 'react';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import MetricsService from '../../../common/services/MetricsService';

import ShutdownView from './ShutdownView';
import SkeletonShutdown from './SkeletonShutdown';
import Constants from "../../../common/Constants";

interface ShutdownComponentProps {
  bpEnabled: boolean;
  metricsService: MetricsService;
}
const ShutdownComponent: React.FC<ShutdownComponentProps> = ({
  bpEnabled,
  metricsService,
}) => {
  const [isShutdownComponent, setIsShutdownComponent] = useState<boolean>(false);
  const [isRenderFailed, setIsRenderFailed] = useState<boolean>(false);
  const { locResources } = useContext(LocResourcesContext);

  const onSendingMetricEvent = (method: string): void => {
    (metricsService as any)[method]();
  };
  const renderSuccess = () => {
    setIsRenderFailed(false);
    onSendingMetricEvent('renderSuccess');
  };

  useEffect(() => {
    if (isShutdownComponent) {
      renderSuccess();
    }
    const metricsTimeout = setTimeout(() => {
      if (!isShutdownComponent) setIsRenderFailed(true);
    }, Constants.RENDER_TIMEOUT);
    return function () {
      clearTimeout(metricsTimeout);
    };
  }, [isShutdownComponent]);

  useEffect(() => {
    locResources && locResources.length !== 0
      ? setIsShutdownComponent(true)
      : setIsShutdownComponent(false);
  }, [locResources]);

  return (
    <div style={{gridColumn: "1 / -1"}}>
      {isShutdownComponent ? (
          <ShutdownView bpEnabled={bpEnabled}/>
      ) : isRenderFailed ? (
          <div></div>
      ) : (
          <React.Fragment>
            <SkeletonShutdown></SkeletonShutdown>
          </React.Fragment>
      )}
    </div>
  );
};

export default ShutdownComponent;
